import type { FC } from "react";
import { Button, ButtonVariant } from "./button.js";

interface SaveAndCancelButtonsProps {
  onSave: () => void;
  isSaving?: boolean;
  isSaveDisabled?: boolean;
  onCancel: () => void;
}

export const SaveAndCancelButtons: FC<SaveAndCancelButtonsProps> = ({
  onSave,
  onCancel,
  isSaving,
  isSaveDisabled,
}) => {
  return (
    <div className="mt-3 flex space-x-2">
      <Button variant={ButtonVariant.Secondary} onClick={onCancel}>
        Cancel
      </Button>
      <Button
        variant={ButtonVariant.Primary}
        onClick={onSave}
        isLoading={isSaving}
        isDisabled={isSaving || isSaveDisabled}
      >
        Save changes
      </Button>
    </div>
  );
};
